import * as n from "react";
function f(e) {
  var r = e.children, t = e.setRef, c = n.useCallback(function(a) {
    t(a);
  }, []);
  return /* @__PURE__ */ n.cloneElement(r, {
    ref: c
  });
}
export {
  f as Item
};
//# sourceMappingURL=Item.mjs.map
